import { withNamespaces } from "react-i18next";
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";

import { isReservedFunction } from "src/modules/data-protection/constants/organizationFunctions";

const FunctionInformation = ({
    t,
    organizationFunction,
    title,
    description,
    titleError,
    onTitleChange,
    onDescriptionChange,
    disabled,
}) => {
    const isReserved = isReservedFunction(organizationFunction);

    return (
        <Card>
            <CardBody>
                <h4 className="card-title">{t("Function Information")}</h4>
                <Row>
                    <Col sm="12" md="6" className="mb-3">
                        <FormGroup className="mb-0">
                            <Label className="form-label" htmlFor="function-title">
                                {`${t("Title")}:`}{" "}
                                <span className="text-danger">*</span>
                            </Label>
                            <Input
                                id="function-title"
                                name="title"
                                type="text"
                                className="form-control"
                                value={title}
                                invalid={titleError}
                                disabled={disabled}
                                onChange={(event) =>
                                    onTitleChange(event.target.value)
                                }
                            />
                            {titleError ? (
                                <div className="invalid-feedback d-block">
                                    {t("This field cannot be blank")}
                                </div>
                            ) : null}
                            {isReserved ? (
                                <small className="text-muted d-block mt-1">
                                    {t("This is a default Function.")}
                                </small>
                            ) : null}
                        </FormGroup>
                    </Col>
                    <Col sm="12" md="6" className="mb-3">
                        <FormGroup className="mb-0">
                            <Label
                                className="form-label"
                                htmlFor="function-description"
                            >
                                {`${t("Description")}:`}
                            </Label>
                            <Input
                                id="function-description"
                                name="description"
                                type="textarea"
                                rows={2}
                                className="form-control"
                                value={description}
                                disabled={disabled}
                                onChange={(event) =>
                                    onDescriptionChange(event.target.value)
                                }
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(FunctionInformation);
